import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import Pricing from './Pricing';
import { PRODUCT_CARD_STATUS } from '../../constants';

function Status({ product, status }) {
  const theme = useTheme();

  if (status?.state === PRODUCT_CARD_STATUS.PURCHASED.state) {
    return (
      <Stack gap={0.5} horizontal sx={{ alignItems: 'center' }}>
        <CheckCircleRoundedIcon color={theme.palette.success.main} sx={{ fontSize: 16 }} />
        <Text
          weight="medium"
          color="green"
          size="sm"
        >
          Purchased
        </Text>
      </Stack>
    );
  }

  if (status?.state === PRODUCT_CARD_STATUS.REQUESTED.state) {
    return (
      <Stack gap={0.5} horizontal sx={{ alignItems: 'center' }}>
        <CheckCircleRoundedIcon color={theme.palette.text.tertiary} sx={{ fontSize: 16 }} />
        <Text
          weight="medium"
          color="tertiary"
          size="sm"
        >
          Requested
        </Text>
      </Stack>
    );
  }

  return <Pricing product={product} />;
}

Status.propTypes = {
  product: PropTypes.shape({
    pricing: PropTypes.shape({
      amount: PropTypes.number,
      formattedPricePerInterval: PropTypes.string
    })
  }),
  status: PropTypes.shape({
    state: PropTypes.string
  })
};

export default Status;
